import React, { ChangeEvent, FormEvent } from "react";
import ReactModal from "react-modal";

interface IDeletionConfirmationDialogProps {
    isOpen: boolean;
    disableDelete?: boolean;

    description?: string | React.ReactChild | null;

    onRequestClose?: (event?: (React.MouseEvent | React.KeyboardEvent)) => void;
    onConfirm?: () => PromiseLike<void>;
    onSuccess?: () => void;
}

interface IDeletionConfirmationDialogState {
    isDeleting: boolean | string;
    canDelete: boolean;

    [name: string]: any;
}

class DeletionConfirmationDialog extends React.Component<IDeletionConfirmationDialogProps, IDeletionConfirmationDialogState> {
    constructor(props: Readonly<IDeletionConfirmationDialogProps>) {
        super(props);

        const state: IDeletionConfirmationDialogState = {
            isDeleting: false,
            canDelete: true,
        };

        this.state = state;

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleElementChanged = this.handleElementChanged.bind(this);
        this.requestClose = this.requestClose.bind(this);
    }

    public render() {
        if (!this.props.isOpen) {
            return null;
        }

        return (
            <ReactModal
                isOpen={this.props.isOpen} onRequestClose={this.requestClose}
                overlayClassName="modal-overlay" className="modal-content" portalClassName="modal-deletion-portal"
                bodyOpenClassName="modal-deletion-open"
                contentLabel="File Upload">
                <form className="input-form" name="deletion-dialog-form" onSubmit={this.handleFormSubmit}>
                    <section className="info-block">
                        <header>
                            <h3>Confirm Delete</h3>
                        </header>

                        {this.props.description !== null ? <span>{this.props.description ? this.props.description : "Are you sure you want to delete this item?"}</span> : null}
                        {this.props.children}
                        {
                            this.state.isDeleting === true
                                ? <div className="spinner lds-dual-ring" />
                                : (typeof this.state.isDeleting) === "string"
                                    ? <span className="error-text">{this.state.isDeleting}</span>
                                    : ""
                        }
                        &nbsp;
                            <div className="action-panel-dialog">
                            <button type="submit" className="button red push-right" disabled={this.props.disableDelete === true}>Yes, Delete</button>
                            <button type="button" className="button" onClick={this.requestClose}>{this.props.disableDelete === true ? "Close" : "No"}</button>
                        </div>
                    </section>
                </form>
            </ReactModal>
        );
    }

    private handleElementChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.value;

        this.setState({
            [name]: value
        });
    }

    private requestClose(e?: (React.MouseEvent | React.KeyboardEvent)) {
        this.setState({
            canDelete: true,
        });

        if (this.state.isDeleting !== true && this.props.onRequestClose) {
            this.props.onRequestClose(e);
        }
    }

    private async handleFormSubmit(e: FormEvent) {
        e.preventDefault();
        e.stopPropagation();

        try {
            this.setState({
                isDeleting: true
            });

            if (this.props.onConfirm) {
                await this.props.onConfirm();
            }

            this.setState({
                isDeleting: false
            }, () => {
                if (this.props.onSuccess) {
                    this.props.onSuccess();
                }

                this.requestClose();
            });
        }
        catch (e) {
            this.setState({
                isDeleting: e.message || e || "Could not delete item"
            });
        }
    }
}

export default DeletionConfirmationDialog;
